<template>
  <div class="form-group lm-date" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <lm-dropdown
      v-if="isEditableByPickedUser"
      class="float-right"
      :tooltip="!disableEditors ? 'Selecciona quién edita este campo' : null"
      template="user-list"
      @input="$emit('editor-change', $event)"
      :value="collaborator"
      :disabled="disableEditors"
      closeAfterPick
    >
      <div class="d-flex align-items-center gap-2">
        {{ collaborator.name || '' }}
        <a-icon type="edit" v-if="!disableEditors" />
      </div>
    </lm-dropdown>
    <div class="d-flex" :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <a-date-picker
        class="flex-100"
        :id="idComputed"
        v-model="date"
        :disabled="disabled"
        :allowClear="allowClear"
        :showTime="showTime"
        :placeholder="config.placeholder"
        :valueFormat="config.dateFormat"
        :format="config.dateFormat"
        :locale="locale"
        :disabled-date="disabledDate"
        size="large"
      />
    </div>
    <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import esES from 'ant-design-vue/es/date-picker/locale/es_ES'
import moment from 'moment'

library.add(faTimes)

export default {
  mixins: [lmInputMixin],
  data () {
    return {
      locale: esES
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    maxDate: {
      type: [String, Date],
      default: null
    },
    config: {
      type: Object,
      default: function () {
        return {
          dateFormat: 'DD-MM-YYYY',
          allowInput: true
        }
      }
    },
    showTime: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (value) {
        if (Object.entries(this.v).length && this.v.$touch) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    }
  },
  methods: {
    disabledDate (current) {
      if (this.maxDate) {
        return current && current > moment(this.maxDate).endOf('day')
      }
      if (this.config.minDate === 'today') {
      // Can not select days before today and today
        return current && current < moment().subtract(1, 'day').endOf('day')
      } else if (this.config.minDate && this.config.minDate !== 'today') {
        return current && current < moment(this.config.minDate).endOf('day')
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .flex-100{
    flex: 1 0 0;
    width: 1%;
  }
</style>
